import { LegalFormalityAccountsApprovalEnum } from '@legal/legal-core/enums/legal-formality-accounts-approval.enum';

export const LEGAL_ACCOUNTS_APPROVAL_STATUS_LABEL: Record<LegalFormalityAccountsApprovalEnum, string> = {
  [LegalFormalityAccountsApprovalEnum.initialized]: 'Initialisé',
  [LegalFormalityAccountsApprovalEnum.notApplicable]: 'Non applicable',
  [LegalFormalityAccountsApprovalEnum.collectScopeToDo]: 'Collecte - cadrage à faire',
  [LegalFormalityAccountsApprovalEnum.collectAwaitingBalanceSheetClosure]: 'Collecte - attente clôture bilan',
  [LegalFormalityAccountsApprovalEnum.collectAssignmentToDo]: 'Collecte - affectation à faire',
  [LegalFormalityAccountsApprovalEnum.pvDocumentToGenerate]: 'PV - document à générer',
  [LegalFormalityAccountsApprovalEnum.pvDocumentToCheck]: 'PV - document à vérifier',
  [LegalFormalityAccountsApprovalEnum.pvMailToSend]: 'PV - courrier à envoyer',
  [LegalFormalityAccountsApprovalEnum.pvSignatureToSend]: 'PV - signature à envoyer',
  [LegalFormalityAccountsApprovalEnum.pvAwaitingSignature]: 'PV - en attente signature',
  [LegalFormalityAccountsApprovalEnum.pvSignatureRefusal]: 'PV - refus signature',
  [LegalFormalityAccountsApprovalEnum.depositToDo]: 'Dépôt - à faire',
  [LegalFormalityAccountsApprovalEnum.depositToSign]: 'Dépôt - à signer',
  [LegalFormalityAccountsApprovalEnum.depositToPay]: 'Dépôt - à payer',
  [LegalFormalityAccountsApprovalEnum.depositAwaitingValidation]: 'Dépôt - attente validation',
  [LegalFormalityAccountsApprovalEnum.depositToRegularize]: 'Dépôt - à régulariser',
  [LegalFormalityAccountsApprovalEnum.depositRejected]: 'Dépôt - rejeté',
  [LegalFormalityAccountsApprovalEnum.depositError]: 'Dépôt - erreur de dépôt',
  [LegalFormalityAccountsApprovalEnum.dossierToClose]: 'Dossier - à clôturer',
  [LegalFormalityAccountsApprovalEnum.completed]: 'Terminé'
};
